import { formatPrice } from "FrontendJsAssets/common/format"

const pointsForm = document.querySelector('.js-points-form')
const pointsDiscountEl = document.querySelector('.js-points-discount')

const changeQuantity = (input) => {
    const rate = parseFloat(pointsForm.dataset.discount.replace(',', '.'))
    const max = parseInt(input.max)
    let value = parseInt(input.value)

    if (value > max) {
        value = max
    }
    if (value < 0) {
        value = 0
    }

    input.value = value
    pointsDiscountEl.innerHTML = formatPrice(value * rate)
}

if (pointsForm) {
    const pointsFormInput = pointsForm.querySelector('[name="points_used"]')

    pointsFormInput.addEventListener('change', () => {
        changeQuantity(pointsFormInput)
    })
    pointsFormInput.addEventListener('keyup', () => {
        changeQuantity(pointsFormInput)
    })

    changeQuantity(pointsFormInput)
}